<template>
  <v-form ref="form" class="claim-form" autocomplete="off">
    <div class="claim-form__section-wrapper">
      <FormGroup :title="$t('ui.injuredPersonInfo')" titleTransform="uppercase">
        <ClaimantInfo v-bind="claimantInfoFormProps" @fieldInput="handleFormSectionFieldInput" />
        <ClaimantSubInfo v-bind="claimantInfoFormProps" @fieldInput="handleFormSectionFieldInput" />
      </FormGroup>
    </div>
    <div class="claim-form__section-wrapper">
      <FormGroup
        :title="$t('ui.providerInfo')"
        titleTransform="uppercase"
        v-if="providerInfoFormProps.shown"
      >
        <ProviderInfo v-bind="providerInfoFormProps" @fieldInput="handleFormSectionFieldInput" />
      </FormGroup>
    </div>
    <v-row>
      <v-col cols="12" md="12">
        <FormSection :title="$t('ui.injuredPersonCurrentlyEnrolledAccidentPlan')">
          <v-radio-group
            @change="
              handleFieldInput(
                CLAIMANT_FIELD_ALIASES.CLAIMANT_CURRENTLY_ENROLLED_ACCIDENT_PLAN,
                arguments[0]
              )
            "
            :value="this[CLAIMANT_FIELD_ALIASES.CLAIMANT_CURRENTLY_ENROLLED_ACCIDENT_PLAN]"
            :rules="['requiredBoolean']"
            row
          >
            <v-radio :value="true" :label="$t('ui.yes')"></v-radio>
            <v-radio :value="false" :label="$t('ui.no')"></v-radio>
          </v-radio-group>
        </FormSection>
      </v-col>
    </v-row>
    <div class="claim-form__section-wrapper" v-if="healthInsuranceInfoFormProps.shown">
      <FormGroup
        class="claim-form__section claim-form__section--smallerTitle"
        :title="healthInsuranceInfoFormProps.shown ? $t('ui.healthInsurancePlan') : ''"
        titleTransform="capitalize"
        titleSize="1.2rem"
        titleWeight="400"
      >
        <HealthInsuranceInfo
          v-bind="healthInsuranceInfoFormProps"
          :accidentPlan="this[CLAIMANT_FIELD_ALIASES.CLAIMANT_CURRENTLY_ENROLLED_ACCIDENT_PLAN]"
          @fieldInput="handleFormSectionFieldInput"
          @addForm="handleAddHealthInsuranceForm"
          @deleteForm="handleDeleteHealthInsuranceForm"
        />
      </FormGroup>
    </div>
    <div class="claim-form__section-wrapper">
      <FormGroup :title="$t('ui.timePlaceDetailsIncident')" titleTransform="uppercase">
        <IncidentDetails
          v-bind="incidentDetailsFormProps"
          @fieldInput="handleFormSectionFieldInput"
        />
      </FormGroup>
    </div>
    <DateSpan :label="$t('ui.currentDate')" />
  </v-form>
</template>

<script>
import { claimFormUsasa, syncForm, validateForm } from '@/mixins';
import ClaimantInfo from '@/components/forms/ClaimFormColorado/partials/ClaimantInfo';
import ProviderInfo from '@/components/forms/ClaimFormColorado/partials/ProviderInfo';
import ClaimantSubInfo from '@/components/forms/ClaimFormColorado/partials/ClaimantSubInfo';
import FormGroup from '@/components/FormGroup';
import HealthInsuranceInfo from '@/components/forms/ClaimFormColorado/partials/HealthInsuranceInfo';
import IncidentDetails from '@/components/forms/ClaimFormColorado/partials/IncidentDetails';
import DateSpan from '@/components/typography/DateSpan';

const FormSection = () => import('@/components/FormSection');

export default {
  name: 'ClaimFormColorado',
  mixins: [claimFormUsasa, syncForm, validateForm],
  components: {
    ClaimantInfo,
    ProviderInfo,
    ClaimantSubInfo,
    FormGroup,
    HealthInsuranceInfo,
    IncidentDetails,
    DateSpan,
    FormSection,
  },
  computed: {
    subInfoLabel() {
      return this.$t('ui.claimantAddress');
    },
  },
  methods: {
    handleAddHealthInsuranceForm() {
      this.$emit('addHealthInsuranceForm');
    },
    handleDeleteHealthInsuranceForm(formKey) {
      this.$emit('deleteHealthInsuranceForm', formKey);
    },
    handleFormSectionFieldInput({ field, value }) {
      this.handleFieldInput(field, value);
    },
  },
};
</script>

<style lang="scss" scoped>
.claim-form__section-wrapper {
  &:nth-child(1n + 2) {
    margin-top: 45px;
  }
}
.claim-form__section {
  &--smallerTitle {
    .form-group-title {
      font-size: 1rem;
    }
  }
}
</style>
